// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.gang\n{\n  border: 1px solid black;\n  box-shadow: 0 0 10px rgba(0,0,0,0.5);\n  margin-top: 1em;\n  margin-bottom: 1em;\n  padding: 0.5em;\n}\n", ""]);
// Exports
module.exports = exports;
